import { Alert, Box, Typography } from "@mui/material";
import { RenderIf, Show } from "@adl/smart-ui-library";
import * as Styled from "./TaskHeader.styles";
import { ITask } from "@/redux/store.types";

type Props = {
  task: ITask;
};

const TaskHeader = ({ task }: Props) => {
  const { document, taskStatusType, rejectedBy } = task;
  const { fileNameOriginal } = document;

  return (
    <Styled.TaskHeader>
      <Styled.TaskHeaderTitle>
        <Typography variant="h6">{fileNameOriginal}</Typography>
        <RenderIf isTrue={taskStatusType !== 5 && !rejectedBy}>
          <Alert severity="error">Needs validating</Alert>
        </RenderIf>
        <RenderIf isTrue={Boolean(taskStatusType !== 5 && rejectedBy)}>
          <Alert severity="error">Rejected</Alert>
        </RenderIf>
        <RenderIf isTrue={taskStatusType !== 5 && document.userSanitised}>
          <Alert severity="info">User sanitised</Alert>
        </RenderIf>
      </Styled.TaskHeaderTitle>
      <Box>
        <Show>
          <Show.When isTrue={taskStatusType === 5}>
            <Styled.TaskHeaderVarifiedIcon />
          </Show.When>
          <Show.Else>
            <Styled.TaskHeaderUnvarifiedIcon />
          </Show.Else>
        </Show>
      </Box>
    </Styled.TaskHeader>
  );
};
export default TaskHeader;
